import Cookies from 'js-cookie'

export default {
  name: 'Page',
  props: ['page'],
  computed: {
    loadedPage() {
      return () => import(
        /* webpackPreload: true */
        /* webpackChunkName: "page-[request]" */
        // eslint-disable-next-line prefer-template
        '../pages/' + this.page
      )
    },
  },
  mounted() {
    this.$store.commit('setLang', Cookies.get('pll_language'))
  },
}
